var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"primary mt-4"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }